import { useCallback } from "react";

import { useTranslation } from "@cinnamon/design-system/hooks";

export const useRequiredFieldError = () => {
  const { t } = useTranslation();
  return useCallback((field_name: string) => t("COMMON.REQUIRED_FIELD_NAME", { field_name }), [t]);
};
